import { Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { VDBIcons } from "@utils/VDBIcons";
import React from "react";
import styled from "styled-components/native";
import { useTheme } from "styled-components/native";
import currency from "currency.js";
import { useUserCurrency } from "../../../hooks/getCurrency";
import { isLooseParcel } from "@utils/product/productValidators";
import { Diamond } from "@src/types/DiamondDetail";
import { useSelector } from "react-redux";

type ParcelPriceSectionContainerProps = {
  itemDetail?: Diamond;
  totalCaratValue?: any;
  translate: any;
};

const ParcelPriceSectionContainer = ({
  itemDetail,
  totalCaratValue,
  translate,
}: ParcelPriceSectionContainerProps) => {
  const userCurrency = useUserCurrency();
  const isCustomApp = useSelector((state: any) => state.appState?.isCustomApp);

  const pricePerCarat = itemDetail?.price_per_carat
    ? currency(itemDetail?.price_per_carat, {
        symbol: userCurrency,
        precision: 0,
      }).format()
    : "-";

  const caratValue =
    Number(String(totalCaratValue ?? "").replace(" ct", "")) || 0;

  const estimatedPrice =
    Number(itemDetail?.price_per_carat) && caratValue
      ? currency(
          Number(itemDetail?.price_per_carat || 0) *
            totalCaratValue.replace(" ct", ""),
          {
            symbol: userCurrency,
            precision: 2,
          }
        ).format()
      : "-";
  const typography = useTypographyStore();
  const theme = useTheme();

  return (
    <PriceMainContainer>
      <VDBText type={typography["Body-M"]} color={theme["core-05"]}>
        {isCustomApp && isLooseParcel(itemDetail)
          ? itemDetail?.sub_title_description
          : `${translate(
              "productDetailPage.pricePerCarat.text"
            )} ${pricePerCarat}`}
      </VDBText>
      <Spacer size={SpaceType.Basic} />
      <VDBText type={typography["H1-B"]} color={theme["core-05"]}>
        {`${translate(
          "productDetailPage.estimatedPriceText.text"
        )} ≈ ${estimatedPrice}`}
      </VDBText>
      <Spacer size={SpaceType.Double} />
      <InfoContainer>
        <VDBIcon
          color={theme["warn-01"]}
          size={20}
          variant={IconsVariant.VDBCustom}
          name={VDBIcons.WARNING}
        />
        <InfoTextContainer>
          <VDBText type={typography["Minor-R"]} color={theme["core-05"]}>
            {`${translate("productDetailPage.parcelTextDisclaimer.text")}`}
          </VDBText>
        </InfoTextContainer>
      </InfoContainer>
    </PriceMainContainer>
  );
};

const PriceMainContainer = styled.View``;

const InfoContainer = styled.View`
  flex-direction: row;
  background-color: ${({ theme }) => theme["warn-02"]};
  justify-content: center;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 8px;
`;
const InfoTextContainer = styled.View`
  flex: 1;
  padding-left: 8px;
`;

export default ParcelPriceSectionContainer;
